import { render, staticRenderFns } from "./GradeList.vue?vue&type=template&id=0480fa32"
import script from "@/controllers/custom/grade/grade-list.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/grade/grade-list.js?vue&type=script&lang=js&external"
import style0 from "./GradeList.vue?vue&type=style&index=0&id=0480fa32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports